import {TransformBase} from "../TranformBase";

import {
  AssistantBackgroundNoiseRecordModel,
  AssistantBackgroundNoiseTypeModel,
} from "@/api/models/assistants/backgroundNoises";
import {Assistant, AssistantBackgroundNoiseType} from "@/api/services";

export class AssistantBackgroundNoisesTransform extends TransformBase {
  public makeTypeModel(
    dto: AssistantBackgroundNoiseType,
  ): AssistantBackgroundNoiseTypeModel {
    switch (dto) {
      case AssistantBackgroundNoiseType.office:
        return AssistantBackgroundNoiseTypeModel.OFFICE;
      case AssistantBackgroundNoiseType.cafe:
        return AssistantBackgroundNoiseTypeModel.CAFE;
      default:
        return null;
    }
  }

  public makeCompactModel(dto: Assistant): AssistantBackgroundNoiseRecordModel {
    return {
      isEnabled: dto.background_noise_enabled,
      type: this.makeTypeModel(dto.background_noise_type),
      volume: dto.background_noise_volume,
    };
  }
}

export const assistantBackgroundNoisesTransform =
  new AssistantBackgroundNoisesTransform();
